module.exports = __webpack_public_path__ + "img/box-empty-s-frontal@2x.d35ca88f.png";